import type { FirebaseApp } from 'firebase/app'
import { collection, doc, getDoc, getFirestore, setDoc } from 'firebase/firestore'

export async function initPrefs(app: FirebaseApp, userId: string) {
  const firestore = getFirestore(app)

  // Ensure prefs is also available for the user, not sure if this is needed though...
  const prefsRef = doc(collection(firestore, 'account-prefs'), userId)

  const snapshot = await getDoc(prefsRef).catch(() => undefined)

  if (!snapshot?.exists()) {
    await setDoc(prefsRef, {}, { merge: true })
  }
}
